/**
 * The field-tracking routes — v17 F4, mounted through the `routes.extra.ts`
 * seam like every feature before them.
 *
 * THE PATHS ARE THE REGISTRY'S (the registers' rule): `field/attendance` and
 * `field/visits` are the two `FIELD_NAV_SECTION` rows in `domain/nav.ts`, and
 * `admin/field-settings` is the Admin section's row. `field/timeline` is a
 * ROUTE, not a nav destination — it needs an engineer and a day, and the
 * registers' rows are where both come from (the `parties/new` precedent: a
 * screen can be reachable without being a sidebar row).
 *
 * NO PROVIDER LAYOUT: three reads and one admin form whose feedback renders
 * in place. A toast provider carrying nothing would be a wrapper with no
 * reader.
 *
 * All four sit INSIDE `RequireCountry` + `AppShell`, so they can rely on
 * `useCountryCode()` and a resolved session.
 */

import type { RouteObject } from 'react-router-dom';

import { AttendanceRegisterPage } from './AttendanceRegisterPage';
import { VisitRegisterPage } from './VisitRegisterPage';
import { TimelinePage } from './TimelinePage';
import { FieldSettingsPage } from './FieldSettingsPage';
import { FieldMapPage } from './FieldMapPage';

export const fieldRoutes: RouteObject[] = [
  { path: 'field/attendance', element: <AttendanceRegisterPage /> },
  { path: 'field/visits', element: <VisitRegisterPage /> },
  { path: 'field/timeline', element: <TimelinePage /> },
  // v22-D — the live field map; nav row 'field-map' in domain/nav.ts.
  { path: 'field/map', element: <FieldMapPage /> },
];

/**
 * Split from `fieldRoutes` so `routes.extra.ts` mounts the admin screen
 * beside the other `admin/*` slices — the Admin surface arrives one route
 * array per work stream (that file's own rule), and this is the field
 * stream's.
 */
export const fieldAdminRoutes: RouteObject[] = [
  { path: 'admin/field-settings', element: <FieldSettingsPage /> },
];
